import { SVGAttributes } from "react"

export function EmailIcon(props: SVGAttributes<SVGSVGElement>) {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M24.1667 6.66666H7.83334C6.90509 6.66666 6.01485 7.03541 5.35847 7.69179C4.70209 8.34817 4.33334 9.23841 4.33334 10.1667V21.8333C4.33334 22.7616 4.70209 23.6518 5.35847 24.3082C6.01485 24.9646 6.90509 25.3333 7.83334 25.3333H24.1667C25.0949 25.3333 25.9852 24.9646 26.6416 24.3082C27.2979 23.6518 27.6667 22.7616 27.6667 21.8333V10.1667C27.6667 9.23841 27.2979 8.34817 26.6416 7.69179C25.9852 7.03541 25.0949 6.66666 24.1667 6.66666ZM24.1667 9L16.5833 14.215C16.406 14.3174 16.2048 14.3713 16 14.3713C15.7952 14.3713 15.594 14.3174 15.4167 14.215L7.83334 9H24.1667Z"
                fill="#C3C7D3"
            />
        </svg>
    )
}
